import angular from 'angular';

import Component from './calendar-day-heading.component';

const CalendarDayHeading = angular
    .module('control-room.commons.data.components.calendar.components.calendar-day-heading', [])
    .component('crCalendarDayHeading', Component);

export default CalendarDayHeading;
